/* eslint-disable camelcase */
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import featureRequestDialog from '../../assets/FeatureRequest.png';
import { selectCurrentEmpid, selectCurrentUser } from '../../pages/login/authSlice';
import './featureRequest.scss';
import { useGetRequestTypesFilterQuery, useSaveFeatureRequestMutation } from './featureRequestSlice';

type FeatureRequestProps = {
    hideFunction: () => void;
    setVisibleFeatureRequest:(value:boolean)=>void;
};

export const FeatureRequest = ({ hideFunction,setVisibleFeatureRequest }: FeatureRequestProps) => {
    const loggedUser = useSelector(selectCurrentUser);
    const [requestType, setRequestType] = useState<any>(null);
    const [requestTypesData, setRequestTypesData] = useState<any>([]);
    const loggedUserId = useSelector(selectCurrentEmpid);
    const [featureRequestComment, setFeatureRequestComment] = useState('');
    const [saveFeatureRequest, saveResponse] = useSaveFeatureRequestMutation();
    const [enableSubmit, setEnableSubmit] = useState(false);

    const { data: requestTypes } = useGetRequestTypesFilterQuery({}, { skip: !loggedUser });


    const onRequestTypeChange = (e: { value: any }) => {
        setRequestType(e.value);
    };
    
    useEffect(() => {
        setRequestTypesData(requestTypes?.data);
    }, [requestTypes]);
    
    useEffect(() => {
        const isFormValid =
            requestType !== null &&
            featureRequestComment !== '' &&
            loggedUserId !== null;
        setEnableSubmit(isFormValid);
    }, [requestType, featureRequestComment, loggedUserId]);

    const Submit = () => {
        if (!requestType || !featureRequestComment  || !loggedUserId) {
          toast.error('Please fill all the fields');
          return;
        }
      
        const featureRequestObj = {
            FeatureTypeId: requestType.feature_type_id,
            FeatureDetails: featureRequestComment,
            CreateBy: loggedUserId,
        };
      
        saveFeatureRequest(featureRequestObj)
          .unwrap()
          .then(() => {
            console.log(saveResponse.data);
            toast.success('Feature Requested Successfully' );
            setVisibleFeatureRequest(true);
            hideFunction();
          })
          .catch((error:any) => {
            console.error(error);
            toast.error('Feature Request Failed');
          });
      };

    return (
        <div>
            <h5 className="mb-3" style={{ fontSize: '24px', fontWeight: '600' }}>
                <img src={featureRequestDialog} alt="Feature Request" className="pe-2" /> Feature Request
            </h5>
            <Divider />

            <h5 className="mt-3" style={{ fontSize: '20px', fontWeight: '600' }}>
                User Details
            </h5>

            <div className="row mt-3">
                <div className="col-md-4">
                    <h5 style={{ fontSize: '16px', fontWeight: '700' }}>Employee Name</h5>
                    <p className="mb-1" style={{ fontSize: '16px', fontWeight: '400' }}>
                        {loggedUser}
                    </p>
                </div>
                <div className="col-md-4">
                    <h5 style={{ fontSize: '16px', fontWeight: '700' }}>Employee Oracle ID</h5>
                    <p className="mb-1" style={{ fontSize: '16px', fontWeight: '400' }}>
                        {loggedUserId}
                    </p>
                </div>
            </div>

            <Divider />

            <h5 className="mt-3" style={{ fontSize: '20px', fontWeight: '600' }}>
            Feature Details
            </h5>

            <div className="row mt-3">
                <div className="col-md-4">
                    <h5 style={{ fontSize: '16px', fontWeight: '600' }}>Feature Type</h5>
                    <Dropdown
                        value={requestType}
                        options={requestTypesData}
                        onChange={onRequestTypeChange}
                        optionLabel="feature_type_name"
                        placeholder="Select Feature Type"
                        className="w-100"
                        style={{ borderRadius: '10px' }}
                    />
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-md-12">
                    <h5 style={{ fontSize: '16px', fontWeight: '600' }}>Comment</h5>
                    <InputTextarea
                        className="w-100"
                        value={featureRequestComment}
                        onChange={(e) => setFeatureRequestComment(e.target.value)}
                        rows={5}
                        maxLength={4000}
                        style={{ borderRadius: '10px' }}
                    />
                </div>
            </div>
            <div className="featureRequestcharLimit">4,000 Character Limit</div>
            <Button
                label="Submit"
                onClick={Submit}
                disabled={!enableSubmit}
                className="btn-primary ps-5 pe-5 float-end mt-3"
                style={{ borderRadius: '12px' }}
            />

            
        </div>
    );
};
